import { render, staticRenderFns } from "./NotificationGroupsMulti.vue?vue&type=template&id=105e725c&"
import script from "./NotificationGroupsMulti.vue?vue&type=script&lang=js&"
export * from "./NotificationGroupsMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports